import type { CSSProperties } from 'react'
import { Container, Lead, ProductTile, Rich, Watermark } from '@vcn/ui'
import { useContent } from '../content'

export function Hero() {
  const { hero } = useContent()

  return (
    <section className="relative pt-[clamp(7rem,17vw,16rem)] pb-16 sm:pb-20">
      <Container className="text-center">
        {/*
          Wasserzeichen und Kachel stehen im Entwurf in einem festen
          Größenverhältnis: 2019 zu 442 Einheiten auf dem Desktop, 404 zu 160
          mobil. Deshalb hängen beide an derselben Variablen `--tile-w`.
        */}
        <div
          className="relative mx-auto mb-16 w-fit sm:mb-20 lg:mb-24"
          style={{ '--tile-w': 'clamp(12rem, 30vw, 20rem)' } as CSSProperties}
        >
          <Watermark
            brand="cap"
            className="w-[calc(var(--tile-w)*2.524)] [--wm-shift:calc(var(--tile-w)*-0.365)] lg:w-[calc(var(--tile-w)*4.566)]"
          />
          <ProductTile brand="cap" width="var(--tile-w)" glow float decorative />
        </div>

        {/* Im Entwurf steht die Zeile auf Desktop einteilig, mobil bricht sie um. */}
        <h1 className="vcn-headline-gradient mx-auto max-w-4xl text-3xl leading-tight font-bold text-balance sm:text-4xl lg:text-[2.6rem]">
          {hero.title.join(' ')}
        </h1>

        <Lead className="mx-auto mt-6 max-w-2xl">
          <Rich text={hero.lead} strong={['CAP GO', 'FLOW', 'SCALE']} />
        </Lead>
      </Container>
    </section>
  )
}
